import request from '../utils/request'
import Api from '../utils/config'

/**
 * 登录，使用get在url中加入参数
 * @param param
 * @returns {Object}
 */
export function login (campaignId,param) {
  return request(Api.login(campaignId), 'POST', param)
}

export function activityList () {
  return request(Api.campaign, 'GET')
}

export function campaignInfo (campaignId) {
  return request(Api.campaignInfo(campaignId), 'GET')
}

export function campaignMenu (campaignId) {
  return request(Api.categories(campaignId), 'GET')
}

export function campaignGoods (campaignId) {
  return request(Api.campaignGoods(campaignId))
}

export function getGoodsByType (typeId) {
  return request(Api.typeGoods(typeId))
}

export function getGoodsByCat (catId) {
  return request(Api.catGoods(catId))
}

export function categorieInfo (typeId) {
  return request(Api.typeGoods(typeId), 'GET')
}

export function goodDetail (goodId) {
  return request(Api.goodDetail(goodId), 'GET')
}

export function goodProduct (goodId) {
  return request(Api.goodProduct(goodId))
}

export function getProductPic (goodId) {
  return request(Api.goodPic(goodId))
}

export function updateCart(campaignId, param){
  return request(Api.updateCart(campaignId), 'POST', param)
}

export function addCart (campaignId, param) {
  return request(Api.addCartProduct(campaignId), 'POST', param)
}

export function getCartNum (campaignId) {
  return request(Api.cartNum(campaignId))
}

// 查询所有订单
export function orderList (campaignId) {
  return request(Api.orderList(campaignId), 'GET')
}

// 查询订单详情
export function orderDetail (orderId) {
  return request(Api.orderInfo(orderId), 'GET')
}

// 查询用户信息
export function userInfo (campaignId) {
  return request(Api.userInfo(campaignId), 'GET')
}

// 查询购物车详情
export function cartInfo (campaignId) {
  return request(Api.cartInfo(campaignId), 'GET')
}

// 查询购物车详情
export function orderPlace (campaignId,goodList) {
  return request(Api.orderPlace(campaignId), 'POST', goodList)
}

//查询商品
export function searchGoods (campaignId, param) {
  return request(Api.search(campaignId), 'POST', param)
}


//查询商品
export function searchGoods2 (campaignId, param) {
  return request(Api.search2(campaignId), 'POST', param)
}



//取消订单
export function cancelOrder (orderId, param){
  return request(Api.cancelOrder(orderId), 'POST', param)
}

export function campaignRule(campaignId) {
  return request(Api.campaignRule(campaignId), 'GET')
}

export function agreementInfo (campaignId) {
  return request(Api.agreementInfo(campaignId), 'GET')
}

export function agreementInfoSubmit (campaignId,param ){
  return request(Api.agreementInfoSubmit(campaignId), 'POST', param)
}

export function checkCampaign (campaignId){
  return request(Api.checkCampaign(campaignId), 'GET')
}

export function campaignInfoLogin (campaignId){
  return request(Api.campaignInfoLogin(campaignId),'GET')
}
export function ruleInfo (campaignId){
  return request(Api.ruleInfo(campaignId),'GET')
}



// WEBPACK FOOTER //
// ./src/service/index.js